/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "api": {
            "nested": {
              "SetRefundMetadataResponse": {
                "nested": {
                  "Status": {
                    "values": {
                      "ERROR": 0,
                      "SUCCESS": 1,
                      "PAYMENT_NOT_FOUND": 2,
                      "REFUND_NOT_FOUND": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.api?.nested?.SetRefundMetadataResponse?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * Response to request to set refund metadata
 *
 * SOURCE SetRefundMetadataResponse @ squareup/payments/set_refund_metadata.proto at 9:1
 */
export const SetRefundMetadataResponse = {};
/**
 * SOURCE Status @ squareup/payments/set_refund_metadata.proto at 10:3
 */
SetRefundMetadataResponse.Status = $root.lookupEnum('squareup.payments.api.SetRefundMetadataResponse.Status').values;